import React from "react";

/**
 *
 * FieldError
 *
 * Inline message under a form field. The color comes from `--field-error`, so
 * a form on a dark background can set a lighter red on its wrapper.
 *
 */
const FieldError = ({
  id,
  message,
  inset = true,
}: {
  id: string;
  message?: string;
  /** Indent to line up with text inside the rounded inputs. */
  inset?: boolean;
}) => {
  if (!message) return null;

  return (
    <p
      id={id}
      // Important so section-level paragraph styles (e.g. LocationDetails)
      // don't turn the message into body copy.
      className={`mt-2 ${inset ? "px-10" : ""} text-sm! sm:text-base! leading-snug! text-[var(--field-error,#dc2626)]!`}
    >
      {message}
    </p>
  );
};

/** Border override for a field that has an error. */
export const fieldErrorBorder = "border-[var(--field-error,#dc2626)]!";

export default FieldError;
